<template>
  <div>
    <vue-data-table
      :headers="headers"
      :data="payments"
      :items-per-page="10"
      :buttons="buttons"
      :summable-columns="summableColumns"
      :show-filter="true"
      :filter-fields="filterFields"
      :filter-data="filter"
      :filter-title="'Filtrer les paiements fournisseurs'"
      :table-actions="tableActions"
      @filter="onFilter"
      @reset="onReset"
    >
      <!-- Supplier Full Name -->
      <template #cell-supplierFullName="{ row }">
        <span v-if="row.supplier">
          {{ row.supplier.fullName }} {{ row.supplier.society }}
        </span>
      </template>

      <!-- Purchase Total Price TTC -->
      <template #cell-purchaseTotalPriceTTC="{ row }">
        <span v-if="row.purchase && row.purchase.totalPriceTTC >= 0">
          {{ parseFloat(row.purchase.totalPriceTTC).toFixed(2) }}
        </span>
      </template>

      <!-- Payment Method -->
      <template #cell-paymentMethod="{ row }">
        <span class="text-primary">{{ row.paymentMethod }}</span>
      </template>

      <!-- Amount -->
      <template #cell-amount="{ row }">
        <span v-if="row.amount >= 0" class="text-success fw-bold">
          {{ parseFloat(row.amount).toFixed(2) }}
        </span>
      </template>

      <!-- Remaining Amount -->
      <template #cell-remainingAmount="{ row }">
        <span v-if="row.remainingAmount >= 0" class="text-danger">
          {{ parseFloat(row.remainingAmount).toFixed(2) }}
        </span>
      </template>
    </vue-data-table>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      filter: {
        supplier_reference: "",
        startDate: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        endDate: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
      },
      filterFields: [
        {
          type: "select",
          model: "supplier_reference",
          label: "Fournisseur",
          options: [],
          labelColumn: "fullName",
          valueColumn: "reference",
          placeholder: "Sélectionner un fournisseur",
        },
      ],
      headers: [
        { field: "reference", label: "Référence", class: "" },
        { field: "supplierFullName", label: "Fournisseur", class: "" },
        { field: "date", label: "Date", class: "" },
        { field: "purchaseTotalPriceTTC", label: "M. Facture", class: "" },
        { field: "paymentMethod", label: "Mode", class: "text-primary" },
        { field: "amount", label: "M. Payé", class: "text-success" },
        { field: "remainingAmount", label: "M. Impayé", class: "text-danger" },
        { field: "remark", label: "Remarque", class: "" },
      ],
      buttons: [
        {
          label: "Détails",
          icon: "bi bi-info-square",
          class: "btn",
          action: (payment) => {
            this.$router.push({
              name: "payments-suppliers-details",
              params: { reference: payment.reference },
            });
          },
        },
      ],
      summableColumns: ["amount", "remainingAmount"],
      tableActions: [
        {
          title: "Actualiser",
          icon: "bi bi-arrow-clockwise",
          class: "btn btn-secondary",
          action: () => {
            this.refresh();
          },
        },
        {
          title: "Imprimer",
          icon: "bi bi-printer",
          class: "btn btn-secondary",
          action: () => {
            this.print(this.filter);
          },
        },
        {
          title: "Créer un nouveau paiement",
          icon: "bi bi-plus-square",
          class: "btn btn-primary",
          action: () => {
            this.$router.push({ name: "payments-suppliers-create" });
          },
        },
      ],
    };
  },
  computed: {
    ...mapGetters("payment", {
      payments: "getAll",
    }),
    ...mapGetters("supplier", {
      suppliers: "getAll",
    }),
    ...mapGetters("auth", {
      userRole: "getUserRole",
    }),
  },
  mounted() {
    this.$store.dispatch("payment/fetchPaymentSupplier");
    this.$store.dispatch("supplier/getAll");
  },
  watch: {
    suppliers: {
      handler(newSuppliers) {
        if (newSuppliers && newSuppliers.length > 0) {
          const supplierField = this.filterFields.find(
            (f) => f.model === "supplier_reference"
          );
          if (supplierField) {
            supplierField.options = newSuppliers;
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("payment/fetchPaymentSupplier");
      // Reset filter
      this.filter = {
        supplier_reference: "",
        startDate: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        endDate: new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
      };
    },
    onFilter(filterData) {
      // Update local filter
      this.filter = { ...filterData };
      // Apply filter via store
      this.$store.dispatch("payment/filter", filterData);
    },
    onReset(resetData) {
      // Reset local filter
      this.filter = {
        supplier_reference: "",
        startDate: resetData.startDate || new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
        endDate: resetData.endDate || new Date(new Date().setFullYear(new Date().getFullYear()))
          .toLocaleString("en-CA")
          .split(",")[0],
      };
      // Reload all payments
      this.$store.dispatch("payment/fetchPaymentSupplier");
    },
    async print(data) {
      await this.$store.dispatch("payment/print", data);
    },
  },
};
</script>
